import {
  DashboardOutlined,
  RobotOutlined,
  SecurityScanOutlined,
  CreditCardOutlined,
  SettingOutlined,
  ContactsOutlined,
  UserOutlined,
  PhoneOutlined,
  MobileOutlined,
  SendOutlined,
  NodeIndexOutlined,
  ControlOutlined,
  TeamOutlined,
  PhoneFilled,
  HistoryOutlined,
  DollarOutlined,
  GlobalOutlined,
  ShopOutlined,
  FileSearchOutlined,
  BgColorsOutlined,
  UsergroupAddOutlined,
  FundOutlined,
  ShoppingCartOutlined,
  MailOutlined,
  CalendarOutlined,
  BarChartOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [
  {
    key: 'dashboards-admin',
    path: `${APP_PREFIX_PATH}/dashboards/admin`,
    title: 'sidenav.dashboard.admin',
    icon: SecurityScanOutlined,
    breadcrumb: false,
    // Seuls les admins ont USERS_DELETE, donc ce menu est réservé aux admins
    permissions: ['USERS_DELETE'],
    submenu: []
  },
  {
    key: 'dashboards-user',
    path: `${APP_PREFIX_PATH}/dashboards/user`,
    title: 'sidenav.dashboard.manager',
    icon: UserOutlined,
    breadcrumb: false,
    permissions: ['DASHBOARD_VIEW'],
    submenu: []
  },
  {
    key: 'dashboards-reports',
    path: `${APP_PREFIX_PATH}/dashboards/reports`,
    title: 'sidenav.dashboard.reports',
    icon: BarChartOutlined,
    breadcrumb: false,
    permissions: ['DASHBOARD_VIEW'],
    submenu: []
  }
]

const adminNavTree = [
  {
    key: 'admin-users',
    path: `${APP_PREFIX_PATH}/admin/users`,
    title: 'sidenav.users',
    icon: UsergroupAddOutlined,
    breadcrumb: false,
    // Seuls les admins ont USERS_DELETE, donc ce menu est réservé aux admins
    permissions: ['USERS_DELETE'],
    submenu: []
  },
  {
    key: 'admin-payment',
    path: `${APP_PREFIX_PATH}/admin/payment`,
    title: 'sidenav.payment',
    icon: DollarOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    // Seuls les admins ont PLANS_CREATE, PLANS_UPDATE, PLANS_DELETE et BILLING_SETTINGS_VIEW
    permissions: ['PLANS_CREATE', 'PLANS_UPDATE', 'PLANS_DELETE', 'BILLING_SETTINGS_VIEW'],
    submenu: [
      {
        key: 'admin-plans',
        path: `${APP_PREFIX_PATH}/admin/plans`,
        title: 'sidenav.plans',
        icon: FundOutlined,
        breadcrumb: false,
        // Seuls les admins peuvent créer/modifier/supprimer des plans
        permissions: ['PLANS_CREATE', 'PLANS_UPDATE', 'PLANS_DELETE'],
        submenu: []
      },
      {
        key: 'admin-payment-gateway',
        path: `${APP_PREFIX_PATH}/admin/payment-gateway`,
        title: 'sidenav.paymentGateway',
        icon: CreditCardOutlined,
        breadcrumb: false,
        // Seuls les admins ont BILLING_SETTINGS_VIEW
        permissions: ['BILLING_SETTINGS_VIEW'],
        submenu: []
      },
      {
        key: 'admin-orders',
        path: `${APP_PREFIX_PATH}/admin/orders`,
        title: 'sidenav.orders',
        icon: ShoppingCartOutlined,
        breadcrumb: false,
        // Seuls les admins ont BILLING_SETTINGS_VIEW, donc ce menu est réservé aux admins
        permissions: ['BILLING_SETTINGS_VIEW'],
        submenu: []
      }
    ]
  },
  {
    key: 'admin-partnerships',
    path: `${APP_PREFIX_PATH}/admin/partnerships`,
    title: 'sidenav.partnerships',
    icon: TeamOutlined,
    breadcrumb: false,
    // Seuls les admins ont USERS_DELETE, donc ce menu est réservé aux admins
    permissions: ['USERS_DELETE'],
    submenu: []
  },
  {
    key: 'admin-leads',
    path: `${APP_PREFIX_PATH}/admin/leads`,
    title: 'sidenav.contactLeads',
    icon: ContactsOutlined,
    breadcrumb: false,
    // Seuls les admins ont accès aux leads globaux
    permissions: ['USERS_DELETE'],
    submenu: []
  },
  {
    key: 'admin-configuration',
    path: `${APP_PREFIX_PATH}/admin/configuration`,
    title: 'sidenav.configuration',
    icon: SettingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    // Seuls les admins ont WEB_PRIVATE_VIEW, donc ce menu est réservé aux admins
    permissions: ['WEB_PRIVATE_VIEW'],
    submenu: [
      {
        key: 'admin-smtp-settings',
        path: `${APP_PREFIX_PATH}/admin/smtp-settings`,
        title: 'sidenav.smtpSettings',
        icon: MailOutlined,
        breadcrumb: false,
        // Seuls les admins ont accès aux paramètres SMTP globaux
        permissions: ['WEB_PRIVATE_VIEW'],
        submenu: []
      }
    ]
  }
]

const voiceNavTree = [{
  key: 'voice',
  path: `${APP_PREFIX_PATH}/voice`,
  title: 'sidenav.voice',
  icon: PhoneOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  permissions: ['CAMPAIGNS_VIEW', 'DEVICES_VIEW'],
  submenu: [
    {
      key: 'voice-dialer',
      path: `${APP_PREFIX_PATH}/voice/dialer`,
      title: 'sidenav.voice.dialer',
      icon: PhoneOutlined,
      breadcrumb: false,
      permissions: ['CAMPAIGNS_VIEW'],
      planRequires: 'dialer',
      submenu: []
    },
    {
      key: 'voice-prepare-device',
      path: `${APP_PREFIX_PATH}/voice/prepare-device`,
      title: 'sidenav.voice.prepareDevice',
      icon: MobileOutlined,
      breadcrumb: false,
      permissions: ['DEVICES_VIEW'],
      planRequires: 'agentIa',
      submenu: []
    },
    {
      key: 'voice-incoming-calls',
      path: `${APP_PREFIX_PATH}/voice/incoming-calls`,
      title: 'sidenav.voice.incomingCalls',
      icon: HistoryOutlined,
      breadcrumb: false,
      permissions: ['CAMPAIGNS_VIEW'],
      planRequires: 'dialer',
      submenu: []
    }
  ]
}]

const voiceAgentNavTree = [{
  key: 'voice-agent',
  path: `${APP_PREFIX_PATH}/voice-agent`,
  title: 'sidenav.voiceAgent',
  icon: RobotOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  permissions: ['FLOWS_VIEW', 'CAMPAIGNS_VIEW', 'SETTINGS_VIEW'],
  submenu: [
    {
      key: 'voice-agent-create-flow',
      path: `${APP_PREFIX_PATH}/voice-agent/create-flow`,
      title: 'sidenav.voiceAgent.createFlow',
      icon: NodeIndexOutlined,
      breadcrumb: false,
      permissions: ['FLOWS_VIEW', 'FLOWS_CREATE'],
      planRequires: 'agentIa',
      submenu: []
    },
    {
      key: 'voice-agent-setup',
      path: `${APP_PREFIX_PATH}/voice-agent/setup`,
      title: 'sidenav.voiceAgent.setup',
      icon: SettingOutlined,
      breadcrumb: false,
      permissions: ['SETTINGS_VIEW'],
      planRequires: 'agentIa',
      submenu: []
    },
    {
      key: 'voice-agent-appointments',
      path: `${APP_PREFIX_PATH}/voice-agent/appointments`,
      title: 'sidenav.voiceAgent.appointments',
      icon: CalendarOutlined,
      breadcrumb: false,
      permissions: ['FLOWS_VIEW'],
      planRequires: 'agentIa',
      submenu: []
    }
  ]
}]

const productivityNavTree = [{
  key: 'productivity',
  path: `${APP_PREFIX_PATH}/productivity`,
  title: 'sidenav.productivity',
  icon: ContactsOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  permissions: ['PHONEBOOK_VIEW', 'AGENTS_VIEW', 'CONTACTS_VIEW', 'CLIENTS_VIEW'],
  submenu: [
    {
      key: 'productivity-phonebook',
      path: `${APP_PREFIX_PATH}/productivity/phonebook`,
      title: 'sidenav.productivity.phonebook',
      icon: ContactsOutlined,
      breadcrumb: false,
      permissions: ['PHONEBOOK_VIEW'],
      submenu: []
    },
    {
      key: 'productivity-agent',
      path: `${APP_PREFIX_PATH}/productivity/agent-management`,
      title: 'sidenav.productivity.agent',
      icon: TeamOutlined,
      breadcrumb: false,
      permissions: ['AGENTS_VIEW'],
      planRequires: 'agentAccess',
      submenu: []
    },
    {
      key: 'productivity-staff',
      path: `${APP_PREFIX_PATH}/productivity/staff-management`,
      title: 'sidenav.productivity.staff',
      icon: UserOutlined,
      breadcrumb: false,
      permissions: ['STAFF_VIEW'],
      submenu: []
    },
    {
      key: 'productivity-clients',
      path: `${APP_PREFIX_PATH}/productivity/clients`,
      title: 'sidenav.productivity.clients',
      icon: ContactsOutlined,
      breadcrumb: false,
      permissions: ['CLIENTS_VIEW'],
      submenu: []
    }
  ]
}]

const configNavTree = [{
  key: 'config',
  path: `${APP_PREFIX_PATH}/config`,
  title: 'sidenav.config',
  icon: ControlOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  permissions: ['DEVICES_VIEW', 'PLANS_VIEW', 'SMTP_VIEW', 'SETTINGS_VIEW', 'ROLES_VIEW'],
  submenu: [
    {
      key: 'config-device-manager',
      path: `${APP_PREFIX_PATH}/config/device-manager`,
      title: 'sidenav.config.deviceManager',
      icon: PhoneOutlined,
      breadcrumb: false,
      permissions: ['DEVICES_VIEW'],
      submenu: []
    },
    {
      key: 'config-subscription',
      path: `${APP_PREFIX_PATH}/config/subscription`,
      title: 'sidenav.config.subscription',
      icon: CreditCardOutlined,
      breadcrumb: false,
      permissions: ['PLANS_VIEW'],
      submenu: []
    },
    {
      key: 'config-smtp',
      path: `${APP_PREFIX_PATH}/config/smtp`,
      title: 'sidenav.config.smtp',
      icon: MailOutlined,
      breadcrumb: false,
      permissions: ['SMTP_VIEW'],
      submenu: []
    },
    {
      key: 'config-role-management',
      path: `${APP_PREFIX_PATH}/config/role-management`,
      title: 'sidenav.config.roleManagement',
      icon: TeamOutlined,
      breadcrumb: false,
      permissions: ['ROLES_VIEW'],
      submenu: []
    }
  ]
}]

const agentNavTree = [{
  key: 'agent',
  path: `${APP_PREFIX_PATH}/agent`,
  title: 'sidenav.agent',
  icon: TeamOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  // Permissions pour l'espace agent (au moins une des permissions)
  permissions: ['DASHBOARD_VIEW', 'CALL_FORCE_VIEW', 'CALL_LOG_VIEW', 'CONTACTS_VIEW', 'PHONEBOOK_VIEW'],
  submenu: [
    {
      key: 'agent-dashboard',
      path: `${APP_PREFIX_PATH}/agent/dashboard`,
      title: 'sidenav.agent.dashboard',
      icon: DashboardOutlined,
      breadcrumb: false,
      permissions: ['DASHBOARD_VIEW'],
      submenu: []
    },
    {
      key: 'agent-dialer',
      path: `${APP_PREFIX_PATH}/agent/dialer`,
      title: 'sidenav.agent.dialer',
      icon: PhoneFilled,
      breadcrumb: false,
      permissions: ['CALL_FORCE_VIEW'],
      planRequires: 'dialer',
      submenu: []
    },
    {
      key: 'agent-call-history',
      path: `${APP_PREFIX_PATH}/agent/call-history`,
      title: 'sidenav.agent.callHistory',
      icon: HistoryOutlined,
      breadcrumb: false,
      permissions: ['CALL_LOG_VIEW'],
      planRequires: 'dialer',
      submenu: []
    },
    {
      key: 'agent-contacts',
      path: `${APP_PREFIX_PATH}/agent/contacts`,
      title: 'sidenav.agent.contacts',
      icon: ContactsOutlined,
      breadcrumb: false,
      permissions: ['CONTACTS_VIEW', 'PHONEBOOK_VIEW'],
      submenu: []
    },
    // {
    //   key: 'agent-appointments',
    //   path: `${APP_PREFIX_PATH}/agent/appointments`,
    //   title: 'sidenav.voiceAgent.appointments',
    //   icon: CalendarOutlined,
    //   breadcrumb: false,
    //   permissions: ['DASHBOARD_VIEW'],
    //   submenu: []
    // }
  ]
}]

const clientNavTree = [{
  key: 'client',
  path: `${APP_PREFIX_PATH}/client/dashboard`,
  title: 'sidenav.client',
  icon: DashboardOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  // Dashboard client nécessite aussi une permission (ex: DASHBOARD_VIEW)
  // pour être protégé comme les autres dashboards
  permissions: ['DASHBOARD_VIEW'],
  submenu: [
    {
      key: 'client-dashboard',
      path: `${APP_PREFIX_PATH}/client/dashboard`,
      title: 'sidenav.client.dashboard',
      icon: DashboardOutlined,
      breadcrumb: false,
      permissions: ['DASHBOARD_VIEW'],
      submenu: []
    }
  ]
}]

const navigationConfig = [
  ...dashBoardNavTree,
  ...adminNavTree,
  ...agentNavTree,
  ...clientNavTree,
  ...voiceNavTree,
  ...voiceAgentNavTree,
  ...productivityNavTree,
  ...configNavTree
]

export default navigationConfig;
